export class AccountAddressBlockType {
    public static readonly CONTACT = "CONTACT";
    public static readonly ACCOUNT = "ACCOUNT";
    public static readonly ACCOUNT_ATTN_CONTACT = "ACCOUNT_ATTN_CONTACT";
    public static readonly ACCOUNT_NAME_AND_NO = "ACCOUNT_NAME_AND_NO";
}
